import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute, useAuth, isAdmin } from "./lib/auth";
import { AppShell } from "./components/AppShell";

import { Landing } from "./pages/Landing";
import { Login } from "./pages/Login";
import { ResetPassword } from "./pages/ResetPassword";

import { StudentDashboard } from "./pages/student/Dashboard";
import { Catalog } from "./pages/student/Catalog";
import { MyCourses } from "./pages/student/MyCourses";
import { CourseDetail } from "./pages/student/CourseDetail";
import { Exam } from "./pages/student/Exam";
import { ExamResult } from "./pages/student/ExamResult";
import { Certificates } from "./pages/student/Certificates";
import { Asistent } from "./pages/Asistent";

import { AdminDashboard } from "./pages/admin/Dashboard";
import { AdminStudents } from "./pages/admin/Students";
import { AdminAdministrators } from "./pages/admin/Administrators";
import { AdminCourses } from "./pages/admin/Courses";
import { CourseEditor } from "./pages/admin/CourseEditor";

function RootRedirect() {
  const { user } = useAuth();
  if (!user) return <Landing />;
  return <Navigate to={isAdmin(user) ? "/admin/dashboard" : "/student/dashboard"} replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route
        path="/student"
        element={
          <ProtectedRoute require="student">
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<StudentDashboard />} />
        <Route path="catalog" element={<Catalog />} />
        <Route path="cursuri" element={<MyCourses />} />
        <Route path="curs/:id" element={<CourseDetail />} />
        <Route path="examen/:courseId" element={<Exam />} />
        <Route path="rezultat" element={<ExamResult />} />
        <Route path="certificate" element={<Certificates />} />
        <Route path="asistent" element={<Asistent />} />
      </Route>

      <Route
        path="/admin"
        element={
          <ProtectedRoute require="admin">
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="studenti" element={<AdminStudents />} />
        <Route path="administratori" element={<AdminAdministrators />} />
        <Route path="cursuri" element={<AdminCourses />} />
        <Route path="curs-editor/:id" element={<CourseEditor />} />
        <Route path="asistent" element={<Asistent />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
